import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function AdminPanel() {
  const navigateTo = useNavigate();

  const handleLogout = () => {
    localStorage.setItem("admin", false);
    navigateTo(`/goztepe`);
  };

  return (
    <>
      <div className="btn-container" style={{ width: "100%" }}>
        <Button
          variant="contained"
          sx={{ margin: 1 }}
          fullWidth
          onClick={() => navigateTo(`/admin-panel`)}
        >
          Yönetici Paneli
        </Button>
        <Button
          variant="contained"
          sx={{ margin: 1 }}
          fullWidth
          onClick={handleLogout}
        >
          Çıkış Yap
        </Button>
      </div>
    </>
  );
}

export default AdminPanel;
